import React, { useCallback, useEffect, useMemo } from 'react';
import { Button } from '@picsio/ui';
import {
  func, number, shape, string,
} from 'prop-types';
import { notifyAboutAssetsLimit } from '../../helpers/inboxes';
import localization from '../../shared/strings';
import picsioConfig from '../../../../../config';
import Icon from '../Icon';
import Logger from '../../services/Logger';
import Toast from '../Toast';
import { navigate } from '../../helpers/history';

const AssetsLimitExceededDialog = (props) => {
  const { destroy, user } = props;
  const { subscriptionFeatures = {}, team = {} } = user;
  const { assetsLimit = 50000, planName } = subscriptionFeatures;
  const { trialEnds } = team;
  const isTrialUser = picsioConfig.isMainApp && !(new Date() > new Date(trialEnds)) && !planName;

  useEffect(() => {
    Logger.log('UI', picsioConfig.isInboxApp ? 'AssetsLimitInboxDialog' : 'AssetsLimitDialog');
  }, []);

  const cancel = useCallback(() => {
    Logger.log(
      'User',
      picsioConfig.isInboxApp ? 'AssetsLimitInboxDialogCancel' : 'AssetsLimitDialogCancel',
    );
    destroy();
  }, [destroy]);

  const submit = useCallback(async () => {
    Logger.log(
      'User',
      picsioConfig.isInboxApp ? 'AssetsLimitInboxDialogOk' : 'AssetsLimitDialogOk',
    );
    if (picsioConfig.isInboxApp) {
      try {
        await notifyAboutAssetsLimit(window.inbox?._id);
        Toast(localization.DIALOGS.ASSETS_LIMIT_INBOX.TEXT_SUCCESS, { type: 'success' });
      } catch (err) {
        Logger.error(new Error('Cant notify inbox owner about assets limit'), { error: err }, [
          'NotifyInboxOwnerFailed',
          { errorMessage: (err && err.message) || 'NoMessage' },
        ]);
      }
    } else {
      navigate('/billing?tab=overview');
    }
    destroy();
  }, [destroy]);

  const dialogTexts = useMemo(
    () => (picsioConfig.isInboxApp ? localization.DIALOGS.ASSETS_LIMIT_INBOX : localization.DIALOGS.ASSETS_LIMIT_APP),
    [],
  );

  const {
    TITLE, TEXT, TEXT_CANCEL, TEXT_OK,
  } = dialogTexts;

  return (
    <div className="simpleDialog revisionFieldsDialog">
      <div className="simpleDialogUnderlayer" />
      <div className="simpleDialogBox">
        <div className="simpleDialogHeader">
          <span className="simpleDialogTitle">{TITLE}</span>
          <span className="simpleDialogBtnCross" onClick={cancel} role="button" tabIndex={0} onKeyPress={cancel}>
            <Icon name="close" />
          </span>
        </div>
        <div className="simpleDialogContent">
          <div className="simpleDialogContentInner">{TEXT(assetsLimit, isTrialUser)}</div>
        </div>
        <div className="simpleDialogFooter">
          <If condition={TEXT_CANCEL}>
            <Button
              color="secondary"
              size="md"
              variant="contained"
              onClick={cancel}
            >
              {TEXT_CANCEL}
            </Button>
          </If>
          <Button
            color="primary"
            size="md"
            variant="contained"
            onClick={submit}
          >
            {TEXT_OK}
          </Button>
        </div>
      </div>
    </div>
  );
};

AssetsLimitExceededDialog.propTypes = {
  destroy: func.isRequired,
  user: shape({
    subscriptionFeatures: shape({
      assetsLimit: number,
      planName: string,
    }),
    team: shape({
      trialEnds: string,
    }),
  }).isRequired,
};

export default AssetsLimitExceededDialog;
